import { Suspense, useState } from "react"

import { Loading } from "web/components"
import { TableView, NoData } from "web/components/ObjectList"

import { useObjectList } from "web/hooks/data"
import useDebouncedValue from "web/hooks/behaviour/useDebouncedValue"

function WrappedTableLayout({
  page,
  setPage,
  user,
  view,
  handleSortChanged,
  handleGroupChanged,
  handleFrozenFieldChanged,
  handleRowsPerPageChanged,
  fetchURL: fetchURLFromProps,
}) {
  const [searchQuery, setSearchQuery] = useState("")
  const debouncedSearchQuery = useDebouncedValue(searchQuery, 300)

  const { sortField, sortDesc, groupField, groupDesc } = view

  const fetchResult = useObjectList({
    subjectType: "task",
    parentSubjectType: "deal",
    searchQuery: debouncedSearchQuery,
    url: fetchURLFromProps,
    view,
    page,
  })

  const {
    detail: data,
    page: pageMeta,
    group_collection: groupCollection,
    grand_totals: grandTotals,
    group_totals: groupTotals,
  } = fetchResult

  function handleRowClicked({ data: task }) {
    window.Turbo.visit(
      `/deals/all/view/${task.deal_id}/workflow/tasks/${task.id}`
    )
  }

  return (
    <div className="flex min-h-0 min-w-0 grow flex-col pl-3 md:pl-5">
      <TableView
        subjectType="task"
        parentSubjectType="deal"
        sortColumn={sortField}
        sortDesc={sortDesc}
        groupColumn={groupField}
        groupDesc={groupDesc}
        page={page}
        handlePageChanged={setPage}
        pageCount={pageMeta.page_count}
        recordCount={pageMeta.record_count}
        onRowClick={handleRowClicked}
        onSort={handleSortChanged}
        onFrozenFieldChanged={handleFrozenFieldChanged}
        onGroup={handleGroupChanged}
        listType={"deal_task"}
        view={view}
        enableExport={true}
        enableScheduledExport={user.is_super_user}
        enableEdit={false}
        enableFavourites={false}
        data={data}
        groupCollection={groupCollection}
        grandTotals={grandTotals}
        groupTotals={groupTotals}
        fields={view.fields}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        rowsPerPage={view.table.rows_per_page}
        onRowsPerPageChanged={handleRowsPerPageChanged}
        emptyState={<NoData listTypeFriendlyName="task" />}
      />
    </div>
  )
}

export default function TableLayout(props) {
  return (
    <Suspense fallback={<Loading inline />}>
      <WrappedTableLayout {...props} />
    </Suspense>
  )
}
